import React from 'react';

import { ReactComponent as SuccessIcon } from '@assets/svg/icon-success.svg';

import { MODAL_NAMES } from '@constants/modalRenderers';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import { useUserResendConfirmMutation } from '@pages/Users/services/useUserResendConfirmMutation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const ResendEmailBtn = ({ user }) => {
  const { t } = useTranslation();

  const { setSecondaryModal } = useModalActions();
  const { mutate: userResendConfirmMutate } = useUserResendConfirmMutation();

  const handleResendEmail = () => {
    setSecondaryModal({
      name: MODAL_NAMES.modalConfirm,
      options: {
        bodyTitle: (
          <>
            <div className={style.subtitleText}>{t('Re-send')}</div>
            {t('Welcome email')}
          </>
        ),
        bodyContent: (
          <>
            {t('Are you sure you want to send welcome email for this user?')}
            <div className={style.confirmUser}>
              <span className={style.confirmUserName}>{user?.full_name}</span>
              <span className={style.confirmUserEmail}>{user?.email}</span>
            </div>
          </>
        ),
        confirmText: t('Send'),
        onConfirm: () =>
          userResendConfirmMutate(
            { id: user.id },
            {
              onSuccess: (result) => {
                const resultStatus = result.data?.status === 'ok';
                showToast({
                  variant: resultStatus ? 'success' : 'error',
                  message: resultStatus ? t('Email sent successfully.') : result.data.message,
                  options: { style: { top: '80px' } },
                });
              },
            },
          ),
      },
    });
  };

  return (
    <div className={style.userStepsResendBtn} onClick={handleResendEmail}>
      {t('Resend Welcome Email')}
    </div>
  );
};

export default ResendEmailBtn;
